<template>

    <div>
        <Aziende :tipo="2"></Aziende>
    </div>

</template>



<script>

import Aziende from '@/components/common/Aziende.vue'


export default {
    name:"Fornitori",
    components:{
        Aziende,
    },
    
}
</script>